"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupI18n = setupI18n;
var _i18next = _interopRequireDefault(require("i18next"));
var _reactI18next = require("react-i18next");
var _i18nextLocalstorageBackend = _interopRequireDefault(require("i18next-localstorage-backend"));
var _i18nextBrowserLanguagedetector = _interopRequireDefault(require("i18next-browser-languagedetector"));
var _moment = _interopRequireDefault(require("moment"));
var _language = require("./language");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function setupI18n(resources, fallbackLanguage, namespaces, defaultNs) {
  _i18next.default.use(_i18nextBrowserLanguagedetector.default).use(_reactI18next.initReactI18next).init({
    supportedLngs: _language.allowedLanguages.map(_language.languageToLocale),
    resources: resources,
    fallbackLng: fallbackLanguage,
    ns: namespaces,
    defaultNS: defaultNs,
    interpolation: {
      escapeValue: false,
      format: function (value, format) {
        if (value instanceof Date) return (0, _moment.default)(value).format(format);
        return value;
      }
    },
    backend: {
      backends: [_i18nextLocalstorageBackend.default],
      backendOptions: [{
        expirationTime: 7 * 24 * 60 * 60 * 1000 // 7 days
      }]
    }
  });
  return _i18next.default;
}